<template>
  <Card title="greeting-expired"> 
    <InfoUser :data="userDetails" />
    <PaymentDetail isVertical="true" :data="paymentDetail" />
  </Card>
</template>

<script>
import InfoUser from '@/components/InfoUser.vue'
import PaymentDetail from '@/components/PaymentDetail.vue'
import Card from '@/components/Card.vue'
import linkToPayData from '@/mixins/linkToPayData.js'

export default {
  name: 'Expired',
  mixins: [linkToPayData],
  components: {
    Card,
    InfoUser,
    PaymentDetail
  },
  data() {
    return {
      
    }
  }
}
</script>